// OPTIONS SELECTORS
let option1 = document.querySelectorAll("[name=option1]");
let option2 = document.querySelectorAll("[name=option2]");
let option3 = document.querySelectorAll("[name=option3]");

//FORM INPUT
let variantId = document.querySelector("[name=id]"); // ID
let productQuantity = document.querySelector("[name=quantity]"); //QUANTITY
let productBarcode = document.getElementById("barcode"); // _BARCODE
const currentHandle = window.location.pathname.split('/products/')[1]?.split('/')[0];
// INPUT
let quantitySelector = document.querySelector("[data-quantity-selector]");

//TEXT HTML
let sizeText = document.querySelectorAll("[data-product-size]");
let specifics = document.querySelectorAll("[data-specs]");
let productPrice = document.querySelectorAll("[data-product-price]");
let compareProductPrice = document.querySelectorAll(
  "[data-product-compare-price]"
);
let comparePriceContainer = document.querySelectorAll(".product-compare-price");

// CONTAINERS
let productPriceContainer = document.querySelectorAll(".product-price");

// BUTTONS
let addToCartButton = document.querySelectorAll("[data-add-to-cart]"); // ADD TO CART BUTTON
let goToCustomButton = document.querySelectorAll(".product-option-button"); //GO TO CUSTOM PRODUCT BUTTON
let cartCustomButton = document.querySelectorAll(
  "[data-add-bundle-custom-cart]"
); // CART CUSTOM BUNDLE BUTTON

// MEDIA
let thumbnail = document.querySelectorAll("[data-product-media-thumbnail]");
let floatingFeaturedImage = document.getElementById("floating__image"); // FLOATING IMAGE
let productFeaturedContainer = document.querySelector(".featured__media");
let productFeaturedSource = document.querySelectorAll(
  "[data-featured-media] source"
);
let productPhotoImage = document.getElementById("ProductPhotoImg");
let initialPhoto = productPhotoImage.src;

// PRODUCT JSON DATA
var addData = {
  id: variantId.value,
  quantity: productQuantity.value,
  properties: {
    _barcode: productBarcode.value,
    _custom: null,
  },
};

//SELECTION
let selectedOption = {
  option1: currentVariant.option1,
  option2: currentVariant.option2,
  option3: currentVariant.option3,
};

let selectedProductVariant;
//サイズのバリエーションボタン26.4.2 リ
let currentColor = null;
//サイズのバリエーションボタン26.4.2 リ
// LISTENER
productPhotoImage.addEventListener("load", () => {
  productFeaturedContainer.style.opacity = 1;
  // 画像読み込み完了時に連打防止フラグを解除
  if (typeof isButtonProcessing !== 'undefined') {
    isButtonProcessing = false;
  }
});

// OPTION SELECTORS => CHANGE VALUE OF VARIABLE [selectedOption]
option1.forEach((option, index) => {
  option.addEventListener("change", function () {
    selectedOption.option1 = this.value;
    // ARのPro / Stdも連動
    setTimeout(() => {
      document.querySelector('.ar-main-tab[data-ar-type="dribble"]')?.click();
      if (index === 0) {
        document.querySelector('.ar-dribble-tab[data-ar-size="std"]')?.click();
      } else if (index === 1) {
        document.querySelector('.ar-dribble-tab[data-ar-size="pro"]')?.click();
      }
    }, 500);
    if (this.checked) selectedOption.option1 = this.value;
    changeVariant(selectedOption);
  });
});

option2.forEach((option) => {
  option.addEventListener("change", function () {
    selectedOption.option2 = this.value;
    if (this.checked) selectedOption.option2 = this.value;
    changeVariant(selectedOption);
  });
});

option3.forEach((option) => {
  option.addEventListener("change", function () {
    selectedOption.option3 = this.value;
    if (this.checked) selectedOption.option3 = this.value;
    changeVariant(selectedOption);
  });
});

// INITIALIZE
for (let i = 0; i < productVariants.length; i++) {
  if (
    selectedOption.option1 == productVariants[i].option1 &&
    selectedOption.option2 == productVariants[i].option2 &&
    selectedOption.option3 == productVariants[i].option3
  ) {
    updateSelectorQuantity(productVariants[i]);
    updateSpecs(productVariants[i]);
    updateNotifyMe(productVariants[i]);
    updateCustomHref(productVariants[i]);
    updateSelectedVariant(productVariants[i]);
    break;
  }
}

//FIND VARIANT FROM PRODUCT
function changeVariant(options) {
  for (let i = 0; i < productVariants.length; i++) {
    if (
      options.option1 == productVariants[i].option1 &&
      options.option2 == productVariants[i].option2 &&
      options.option3 == productVariants[i].option3
    )
      return onSelectChange(productVariants[i]);
  }
}

// FUNCTIONS
function getProductQuantityInCart(variant) {
  let cartProductQuantity = 0;

  cartInfo.forEach((item) => {
    if (item.variant_id == variant.id) cartProductQuantity += item.quantity;
  });

  return cartProductQuantity;
}
async function updateCartInfo() {
  const response = await fetch("/cart.js");
  const cart = await response.json();

  cartInfo = cart.items;

  return cartInfo;
}

function updateUrl(id) {
  const url = new URL(window.location);
  url.searchParams.set("variant", id);
  window.history.replaceState({}, "", url);
}

function updateMainImage(image) {
  if (image.featured_image) {
    if (initialPhoto !== image.featured_image) {
      productFeaturedContainer.style.opacity = 0.5;
      initialPhoto = image.featured_image;
    }

    productFeaturedSource.forEach((source) => {
      source.srcset = `${image.featured_image}&width=${source.width} 1x,${
        image.featured_image
      }&width=${source.width * 2} 2x `;
    });
    if (currentHandle === 'rb-gmset') {
      return;
    }
    floatingFeaturedImage.src = image.featured_image + "&width=100";
  } else
    productFeaturedSource.src =
      "//cdn.shopify.com/shopifycloud/shopify/assets/no-image-100-c91dd4bdb56513f2cbf4fc15436ca35e9d4ecd014546c8d421b1aece861dfecf_95x95@2x.gif";
}
function updateMedia(color) {
  thumbnail.forEach((element) => {
    if (element.alt == color || element.alt == "all")
      element.style.display = "block";
    else element.style.display = "none";
  });

  // 同期的に処理順序を保証
  requestAnimationFrame(() => {
    // 1. 配列更新
    swipeState.visibleThumbnails = Array.from(thumbnail).filter((img) => {
      const computedStyle = window.getComputedStyle(img);
      return computedStyle.display !== 'none';
    });
    
    // 2. インデックス更新（配列更新後）
    if (productPhotoImage && productPhotoImage.src) {
      swipeState.currentImageIndex = getCurrentImageIndex(productPhotoImage.src);
      updateActiveThumbnail(swipeState.currentImageIndex);
    }
    
    // 3. ボタン表示更新
    updateSwipeNavButtons();
  });
}

function updatePrice(price) {
  productPrice.forEach((el) => {
    el.textContent = formatter.format(price.price / 100);
    el.dataset.productPrice = price.price;
  });
}
function updateComparePricing(price) {
  if (price.compare_at_price > price.price && price.compare_at_price) {
    compareProductPrice.forEach((el) => {
      el.textContent = formatter.format(price.compare_at_price / 100);
      el.dataset.productPrice = price.compare_at_price;

      productPriceContainer.forEach((e) => {
        e.classList.add("compare");
      });
    });
  } else {
    productPriceContainer.forEach((e) => {
      e.classList.remove("compare");
    });
  }
}
function updateSelectorQuantity(inventory) {
  let currentCartInventory = getProductQuantityInCart(inventory);
  let optionMaker = "";
  let quantityIn = 1;

  if (inventory.inventory_policy == "deny") {
    //INVENTORY CHECKER
    quantityIn = inventory.inventory - currentCartInventory;

    for (let i = 1; i <= quantityIn; i++) {
      if (i > 30) break;
      optionMaker += `<option value='${i}'>${i}</option>`;
    }

    if (quantityIn <= 0) {
      optionMaker += `<option>1</option>`;
      disableAddToCartButton();
    } else {
      enableAddToCartButton();
    }

    quantitySelector.innerHTML = optionMaker;
  }
  if (inventory.inventory_policy == "continue") {
    //INVETORY POLICY [CONTINUE] TO BUY EVEN IF LESS THAN ZERO
    for (let i = 1; i <= 10; i++) {
      optionMaker += `<option value='${i}'>${i}</option>`;
    }
    quantitySelector.innerHTML = optionMaker;
    enableAddToCartButton();
  }
  productQuantity.value = quantitySelector.value;
}
function updateNotifyMe(inventory) {
  let notifyMeBtn = document.querySelectorAll(".osf__container ");

  if (notifyMeBtn)
    notifyMeBtn.forEach((btn) => {
      if (inventory.inventory <= 0) btn.style.display = "block";
      else btn.style.display = "none";
    });
}
function updateProductBarcode(variant) {
  productBarcode.value = variant.barcode;
}
function updateCustomHref(variant) {
  const productNotice = document.querySelector(".product-notice");
  const quantity = quantitySelector ? quantitySelector.value : 1;
  document.querySelectorAll("[data-custom-product-link]").forEach((e) => {
    if (variant.custom == false) {
      e.href = `/products/custom-${variant.sku}?customvariantid=${variant.id}&barcode=${variant.barcode}&pr=${variant.price}&limit=${variant.inventory}&quantity=${quantity}`;
      e.style.display = "block";

      if (productNotice) productNotice.style.display = "block";
    } else {
      e.style.display = "none";
      if (productNotice) productNotice.style.display = "none";
    }
  });
}

function updateSelectedVariant(variant) {
  selectedProductVariant = variant;
}

// Helper function to check if a value is empty
function isEmptyValue(value) {
  // Check for null, undefined, empty string, or 'null' string
  if (!value || value === '' || value === 'null') {
    return true;
  }
  // Check for empty arrays or arrays with only 'null' values
  if (Array.isArray(value)) {
    return value.length === 0 || (value.length === 1 && value[0] === 'null');
  }
  return false;
}

// 配列値を「・」区切りの文字列にフォーマットする
function formatBundleArrayValue(value) {
  if (!value) return '';
  
  // オブジェクト形式 {value: [...]} の場合
  if (value && typeof value === 'object' && value.value) {
    if (Array.isArray(value.value)) {
      return value.value.join('・');
    }
    return String(value.value);
  }
  
  // 配列の場合
  if (Array.isArray(value)) {
    return value.join('・');
  }
  
  // オブジェクトの場合（valueプロパティがない）
  if (typeof value === 'object') {
    return '';
  }
  
  return String(value);
}

// バンドル商品のスペックをDOMに反映する
function updateBundleProductSpecs(productHandle, variantSpecs) {
  const specBlock = document.querySelector(
    `.specification[data-bundle-product="${productHandle}"]`
  );
  if (!specBlock) return;
  
  // 各スペック項目を更新
  const specs = {
    sku: variantSpecs.sku,
    size_classification: variantSpecs.size_classification,
    target: formatBundleArrayValue(variantSpecs.target),
    measurement: variantSpecs.measurement,
    weight: variantSpecs.weight,
    material: formatBundleArrayValue(variantSpecs.material),
    method: formatBundleArrayValue(variantSpecs.method),
    color: variantSpecs.color,
    usage: formatBundleArrayValue(variantSpecs.usage),
    accessories: formatBundleArrayValue(variantSpecs.accessories),
  };
  
  Object.entries(specs).forEach(([key, value]) => {
    const el = specBlock.querySelector(`[data-specs="${key}"]`);
    if (el) {
      // 値がある場合のみ更新（空の場合は現状維持）
      // これにより、bundleProductsDataに値がない場合でも
      // Liquidで表示していた値が消えない
      if (value) {
        el.textContent = value;
        const li = el.closest('li');
        if (li) {
          li.style.display = '';
        }
      }
      // 値が空の場合は何もしない（Liquidでの初期表示を維持）
    }
  });
}

// バンドル商品のタイトルに対応するメイン商品のオプション位置を見つける
function findOptionPositionForBundleProduct(bundleProductTitle) {
  if (typeof bundleOptionsData === 'undefined') {
    return null;
  }
  
  // メイン商品のオプション名にバンドル商品のタイトルが含まれているかチェック
  for (const option of bundleOptionsData) {
    if (option.name && option.name.includes(bundleProductTitle)) {
      return option.position; // 1, 2, 3...
    }
  }
  
  return null;
}

// メイン商品のバリエーションに対応するバンドル商品のバリエーションを見つける
function findMatchingBundleVariant(bundleProduct, mainVariant) {
  if (!bundleProduct.variants || bundleProduct.variants.length === 0) {
    return null;
  }
  
  // バンドル商品のタイトルに対応するメイン商品のオプション位置を動的に取得
  const optionPosition = findOptionPositionForBundleProduct(bundleProduct.title);
  
  if (!optionPosition) {
    // 対応するオプションがない場合は最初のバリエーションを返す
    return bundleProduct.variants[0];
  }
  
  // オプション位置に対応するメイン商品のオプション値を取得
  const optionKey = `option${optionPosition}`;
  const targetOptionValue = mainVariant[optionKey];
  
  if (!targetOptionValue) {
    // オプション値がない場合は最初のバリエーションを返す
    return bundleProduct.variants[0];
  }
  
  // バンドル商品のバリエーションで、オプション値が一致するものを探す
  const matchedVariant = bundleProduct.variants.find(bv => {
    return bv.option1 === targetOptionValue || 
           bv.option2 === targetOptionValue || 
           bv.option3 === targetOptionValue;
  });
  
  // 見つからない場合は最初のバリエーションを返す
  return matchedVariant || bundleProduct.variants[0];
}

// バンドル商品のスペック更新（デフォルトテンプレート用）
function updateBundleSpecs(variant) {
  // bundleProductsData が定義されていない場合は何もしない
  if (typeof bundleProductsData === 'undefined') {
    console.log('[bundle-specs] bundleProductsData is not defined');
    return;
  }
  
  // 各バンドル商品のスペックを更新
  bundleProductsData.forEach((bundleProduct) => {
    const matchedVariant = findMatchingBundleVariant(bundleProduct, variant);
    if (matchedVariant) {
      updateBundleProductSpecs(bundleProduct.handle, matchedVariant);
    }
  });
}

function updateSpecs(variant) {
  // Check if this is a bundle product (has data-bundle-product attribute)
  const isBundleProduct = document.querySelector('.specification[data-bundle-product]');
  if (isBundleProduct) {
    // Run bundle-specific updater (currently logging only)
    updateBundleSpecs(variant);
    return;
  }

  // SKU
  specifics[1].textContent = variant.sku;
  specifics[1].parentElement.style.display = isEmptyValue(variant.sku) ? 'none' : '';

  // Size Classification
  specifics[2].textContent = variant.size_classification;
  specifics[2].parentElement.style.display = isEmptyValue(variant.size_classification) ? 'none' : '';

  // Target
  specifics[3].textContent = variant.target;
  specifics[3].parentElement.style.display = isEmptyValue(variant.target) ? 'none' : '';

  // Measurement
  specifics[4].textContent = variant.measurement;
  specifics[4].parentElement.style.display = isEmptyValue(variant.measurement) ? 'none' : '';

  // Weight
  specifics[5].textContent = variant.weight;
  specifics[5].parentElement.style.display = isEmptyValue(variant.weight) ? 'none' : '';

  // Material
  specifics[6].textContent = variant.material;
  specifics[6].parentElement.style.display = isEmptyValue(variant.material) ? 'none' : '';

  // Method
  specifics[7].textContent = variant.method;
  specifics[7].parentElement.style.display = isEmptyValue(variant.method) ? 'none' : '';

  // Color
  specifics[8].textContent = variant.color;
  specifics[8].parentElement.style.display = isEmptyValue(variant.color) ? 'none' : '';

  // Usage
  specifics[9].textContent = variant.usage;
  specifics[9].parentElement.style.display = isEmptyValue(variant.usage) ? 'none' : '';

  // Accessories
  specifics[10].textContent = variant.accessories;
  specifics[10].parentElement.style.display = isEmptyValue(variant.accessories) ? 'none' : '';

  // Update size text separately
  sizeText.forEach((size) => {
    size.textContent = variant.size_classification;
  });
}

function enableAddToCartButton() {
  addToCartButton.forEach((button) => {
    if (!productRelease) button.textContent = productComingSoonTxt;
    else {
      button.textContent = productInStockTxt;
      button.classList.remove("disabled");
      button.removeAttribute("disabled");
      goToCustomButton.forEach((button) => {
        button.classList.remove("disabled");
      });
      cartCustomButton.forEach((button) => {
        button.classList.remove("disabled");
        button.removeAttribute("disabled");
      });
    }
  });
}

function disableAddToCartButton() {
  addToCartButton.forEach((button) => {
    if (!productRelease) button.textContent = productComingSoonTxt;
    else button.textContent = productSoldOutTxt;

    button.classList.add("disabled");
    button.setAttribute("disabled", "");
  });
  goToCustomButton.forEach((button) => {
    button.classList.add("disabled");
    button.setAttribute("href", "#");
  });
  cartCustomButton.forEach((button) => {
    button.classList.add("disabled");
    button.setAttribute("disabled", true);
  });
}

//VARIANT SELECTOR CHANGES AFTERMATH [MAIN SWITCH]
function onSelectChange(variant) {
  variantId.value = variant.id; //update FORM input[value='id']
  updateUrl(variant.id); //update URL
  updateMainImage(variant); //update main image
  updateMedia(variant.option1); //update thumbnail
  updateProductBarcode(variant); //update barcode
  updatePrice(variant); //update price
  updateComparePricing(variant); //update compare Pricing
  updateSelectorQuantity(variant); //update selector quantity
  updateCustomHref(variant); //update custom product href

  updateSelectedVariant(variant); //update selectedVariant
  //サイズのバリエーションボタン26.4.2 リ
  updateSizeButtons(variant);
  //サイズのバリエーションボタン26.4.2 リ
  if (specifics[1]) updateSpecs(variant); //update specs text
  updateNotifyMe(variant); // ORDERSIFY APP BUTTON
}

/*******************************/
// UPDATE MAIN IMAGE WHEN THUMBNAIL IS CLICKED

let thumbnailSelection = document.querySelector(".thumbnail"); //THUMBNAILS

if (thumbnailSelection)
  thumbnailSelection.addEventListener("click", (e) => {
    if (e.target.dataset.productMediaThumbnail == "") {
      if (initialPhoto !== e.target.src) {
        productFeaturedContainer.style.opacity = 0.5;
        initialPhoto = e.target.src;
      }

      productFeaturedSource.forEach((src) => {
        src.srcset = `${e.target.src.replace(
          "&width=100",
          "&width=" + src.width
        )} 1x,${e.target.src.replace(
          "&width=100",
          "&width=" + src.width * 2
        )} 2x `;
      });

      // 追加: クリックされた画像のインデックスを更新
      swipeState.currentImageIndex = getCurrentImageIndex(e.target.src);
      updateActiveThumbnail(swipeState.currentImageIndex);
    }
  });

/*******************************/

// RERENDER ALL PRODUCT PRICE ea. Y1000
function multiplyPricing(value) {
  productPrice.forEach((el) => {
    el.textContent = formatter.format((el.dataset.productPrice / 100) * value);
  });
  compareProductPrice.forEach((el) => {
    el.textContent = formatter.format(
      (el.dataset.productComparePrice / 100) * value
    );
  });
}

//UPDATE VALUES OF input[quantity]
quantitySelector.addEventListener("change", function () {
  multiplyPricing(quantitySelector.value);
  productQuantity.value = quantitySelector.value;
  if (selectedProductVariant) {
    updateCustomHref(selectedProductVariant);
  }
});

/*******************************/
// FORM ADD TO CART
const form = document.getElementById("productForm");
let customProduct = document.getElementById("customProduct");
let mainFeaturedMedia = document.querySelector(".main-featured-media");


async function additionalsToCartHLeague2026(event, button) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  const selectedVariantTitle = selectedProductVariant.title;
  const selectedVariantSku = selectedProductVariant.sku;

  let naireProperty = {
    文字エリアA行数: "1行",
    文字エリアA: "LEAGUE H ※指定ロゴ",
    _CustomTarget: selectedVariantSku,
  };

  if (selectedVariantTitle !== "チーム名加工無し") {
    naireProperty = {
      文字エリアC行数: "1行",
      文字エリアC: `${selectedVariantTitle}`,
      ...naireProperty,
    };
  }

  const hleague2026SkuToVariantId = {
    "H3A5000-YB-LH-00": 53544473755966,
    "H3A5000-YB-LH-01": 53544474935614,
    "H3A5000-YB-LH-02": 53544477458750,
    "H3A5000-YB-LH-03": 53544477688126,
    "H3A5000-YB-LH-04": 53544477753662,
    "H3A5000-YB-LH-05": 53544477819198,
    "H3A5000-YB-LH-06": 53544477983038,
    "H3A5000-YB-LH-07": 53544478179646,
    "H3A5000-YB-LH-08": 53544478212414,
    "H3A5000-YB-LH-09": 53544478540094,
    "H3A5000-YB-LH-10": 53544478605630,
    "H3A5000-YB-LH-11": 53544480342334,
    "H3A5000-YB-LH-12": 53544486142270,
    "H3A5000-YB-LH-13": 53544489124158,
    "H3A5000-YB-LH-14": 53544489877822,
    "H2A5000-YB-LH-00": 53544517075262,
    "H2A5000-YB-LH-01": 53544517599550,
    "H2A5000-YB-LH-02": 53544518189374,
    "H2A5000-YB-LH-03": 53544518287678,
    "H2A5000-YB-LH-04": 53544525070654,
    "H2A5000-YB-LH-05": 53544525103422,
    "H2A5000-YB-LH-06": 53544525168958,
    "H2A5000-YB-LH-07": 53544525234494,
    "H2A5000-YB-LH-08": 53544525300030,
    "H2A5000-YB-LH-09": 53544525627710,
    "H2A5000-YB-LH-10": 53544525889854,
    "H2A5000-YB-LH-11": 53544529297726,
    "H2A5000-YB-LH-12": 53544529756478,
  };

  const cpbVariantId = hleague2026SkuToVariantId[selectedVariantSku];

  if (!cpbVariantId) {
    console.warn(
      `H League 2026 CPB variant ID is not set for SKU: ${selectedVariantSku}`
    );
    await addProductToCart(button);
    return;
  }

  // 親商品をカート投入する際に _custom を必ず付与（紐付け判定用）
  let customPropInput = form.querySelector('input[name="properties[_custom]"]');
  if (!customPropInput) {
    customPropInput = document.createElement("input");
    customPropInput.type = "hidden";
    customPropInput.name = "properties[_custom]";
    form.appendChild(customPropInput);
  }
  customPropInput.value = "custom";

  let formData = {
    items: [
      {
        id: cpbVariantId,
        quantity: productQuantity.value,
        properties: naireProperty,
      },
    ],
  };

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      console.error(
        "H League 2026 CPB add failed",
        await response.text()
      );
      if (button) button.removeAttribute("disabled");
      return;
    }

    await addProductToCart(button);
  } catch (error) {
    console.error("H League 2026 CPB add fetch error", error);
    if (button) button.removeAttribute("disabled");
  }
}
async function additionalsToCartSilverOnly(event, button) {
  console.log("additionalsToCartSilverOnly");

  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  const selectedVariantSku = selectedProductVariant.sku;

  const naireProperty = {
    "片側／両面を選択": "両側 (1,540)",
    "文字エリアA行数": "1行",
    "文字エリアA": "PLATEONLY",
    "文字エリアB行数": "1行",
    "文字エリアB": "PLATEONLY",
    "_CustomTarget": selectedVariantSku,
  };

  // 現在の商品handleを取得
  const productHandle = window.location.pathname
    .match(/\/products\/([^/?#]+)/)?.[1];

  // 商品ごとの名入れ商品 Variant ID
  const silverOnlyHandleToVariantId = {
    "ra0040-test": 54358113648958,
    "ra0030-test": 54360301470014,
  };

  const cpbVariantId = silverOnlyHandleToVariantId[productHandle];

  console.log("productHandle:", productHandle);
  console.log("cpbVariantId:", cpbVariantId);

  if (!cpbVariantId) {
    console.warn(
      `Silver Only CPB variant ID is not set for handle: ${productHandle}`
    );

    await addProductToCart(button);
    return;
  }

  // 親商品に _custom を付与
  let customPropInput = form.querySelector(
    'input[name="properties[_custom]"]'
  );

  if (!customPropInput) {
    customPropInput = document.createElement("input");
    customPropInput.type = "hidden";
    customPropInput.name = "properties[_custom]";
    form.appendChild(customPropInput);
  }

  customPropInput.value = "custom";

  const formData = {
    items: [
      {
        id: cpbVariantId,
        quantity: productQuantity.value,
        properties: naireProperty,
      },
    ],
  };

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("Silver Only CPB add failed:", data);

      showActionToast({
        message:
          data.description ||
          data.message ||
          "カートに追加できませんでした。",
      });

      button.removeAttribute("disabled");
      return;
    }

    // CPB追加成功後、親商品を追加
    await addProductToCart(button);

  } catch (error) {
    console.error(
      "Silver Only CPB add fetch error:",
      error
    );

    showActionToast({
      message: "通信エラーが発生しました。",
    });

    button.removeAttribute("disabled");
  }
}
async function additionalsToCartPelada(button) {
  // 本番のステッカー
  const presentVariantId = 51434421682494;

  // BPのステッカー
  // const presentVariantId = 45293991493783;

  const formData = {
    items: [
      {
        id: presentVariantId,
        quantity: productQuantity.value,
      },
    ],
  };

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    if (!response.ok) {
      console.error("ステッカー追加エラー:", data);
      showActionToast({
        message:
          data.description ||
          data.message ||
          "カートに追加できませんでした。",
      });
      button.removeAttribute("disabled");
      return;
    }
    await addProductToCart(button);
  } catch (error) {
    console.error(error);
    showActionToast({
      message: "通信エラーが発生しました。",
    });
    button.removeAttribute("disabled");
  }
}
async function additionalsToCartHandPumpBlue(button) {
  const handPumpBlueVariantId = 41515626299586;

  const alreadyInCart = cartInfo.some(
    (item) => item.variant_id == handPumpBlueVariantId
  );

  if (alreadyInCart) {
    await addProductToCart(button);
    return;
  }

  const formData = {
    items: [
      {
        id: handPumpBlueVariantId,
        quantity: 1,
      },
    ],
  };

   try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("ハンドポンプ追加エラー:", data);

      showActionToast({
        message:
          data.description ||
          data.message ||
          "カートに追加できませんでした。",
      });

      button.removeAttribute("disabled");
      return;
    }

    await addProductToCart(button);
  } catch (error) {
    console.error(error);

    showActionToast({
      message: "通信エラーが発生しました。",
    });

    button.removeAttribute("disabled");
  }
}
async function additionalsToCartPentagonDeluxe(button) {
  // const pentagonDeluxeVariantId = 41708201246871; // 開発ストア
  const pentagonDeluxeVariantId = 41509381734594; // 本番ストア
  const pentagonBlackVariantId = 41509899206850; // 2026.5.11hpgbk対応

  const alreadyInCart = cartInfo.some(
    (item) => item.variant_id == pentagonBlackVariantId
  );
  if (alreadyInCart) {
    await addProductToCart(button);
    return;
  }

  const formData = {
    items: [
      {
        id: pentagonBlackVariantId,
        quantity: 1,
      },
    ],
  };

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("ペンタゴン追加エラー:", data);

      showActionToast({
        message:
          data.description ||
          data.message ||
          "カートに追加できませんでした。",
      });

      button.removeAttribute("disabled");
      return;
    }

    await addProductToCart(button);
  } catch (error) {
    console.error(error);

    showActionToast({
      message: "通信エラーが発生しました。",
    });

    button.removeAttribute("disabled");
  }
}
async function additionalsToCartBasketballBag(button) {
  const basketballBagVariantId = 41537596620994; // バスケットボール1個入れ

  const alreadyInCart = cartInfo.some(
    (item) => item.variant_id == basketballBagVariantId
  );

  if (alreadyInCart) {
    await addProductToCart(button);
    return;
  }

  const formData = {
    items: [
      {
        id: basketballBagVariantId,
        quantity: 1,
      },
    ],
  };

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("バスケットボールバッグ追加エラー:", data);

      showActionToast({
        message:
          data.description ||
          data.message ||
          "カートに追加できませんでした。",
      });

      button.removeAttribute("disabled");
      return;
    }

    await addProductToCart(button);

  } catch (error) {
    console.error(error);

    showActionToast({
      message: "通信エラーが発生しました。",
    });

    button.removeAttribute("disabled");
  }
}

addToCartButton.forEach((btn) => {
  btn.addEventListener("click", async function (event) {
    if (window.preorderEvent) { //予約商品の場合は直接カート遷移
      form.submit();
      return;
    }
    btn.setAttribute("disabled", "");
    await updateCartInfo();
    let pageUrl = window.location.href;
    const selectedVariantSku = selectedProductVariant.sku;//26.9.10判断基準sku

    const blazzaSilverHandles = [
      "products/ra0040-test",
      "products/ra0030-test",
    ]
    const isBlazzaSilver = blazzaSilverHandles.some((handle) =>
      pageUrl.includes(handle)
    );

    const hleague2026ProductHandles = [
      "products/h2a5000-yb-lh",
      "products/h3a5000-yb-lh",
    ];
    const isHLeague2026 = hleague2026ProductHandles.some((handle) =>
      pageUrl.includes(handle)
    );
      const peladaProductHandles = [
      // "products/f5k5000",
      // "products/f5k5001",
      "products/f5k4000",
      "products/f5k3000",
      // "products/f4k5000",
      "products/f4k4000",
      "products/f4k3000",
      "products/f9k4000",
      "products/f9k3000",
      "products/f3k9200",
      "products/f5k9100",
      "products/f5k9200",
      "products/f5k9300",
    ];
    const isPelada = peladaProductHandles.some((handle) =>
      pageUrl.includes(handle)
    );

    const handPumpProcuctHandles = [
      "products/adf520",
      "products/adf420mol",
      "products/adf420b",
      "products/adf420f", 
      "products/adf420f",
      "products/adf520f",
      "products/adf540w",
      "products/adf541w",
      "products/adf550dfl",
      "products/adf551dfl",
      "products/adf561nl",
    ];
    // const isHandPump = handPumpProcuctHandles.some((handle) =>
    //   pageUrl.includes(handle)
    // );
    // const pentagonDeluxeProductHandles = ["products/b5g5000"]; // 開発ストア
    const pentagonDeluxeProductHandles = [
      "products/b7g4800",
      // "products/b5g5000",
      "products/f4n5000",
      "products/f5n5000",
      "products/f4k5000",
      "products/f5k5000",
      "products/f5k5001",
      "products/b7g5000-q5z",
      "products/b6g5000-w6g",
      "products/b7g5000-bl0",
      "products/b7g5000-bl1"
    ]; // 本番ストア
    // const isPentagonDeluxe = pentagonDeluxeProductHandles.some((handle) =>
    //   pageUrl.includes(handle)
    // );
    //26.9.10判断基準sku-----------Start
    const pentagonDeluxeProductSkus = [
      "B7G4800",
      "B6G4800",
      "F4N5000",
      "F5N5000",
      "F4K5000",
      "F5K5000",
      "F5K5001",
      "B7G5000-Q5Z",
      "B6G5000-W6G",
      "B7G5000-BL0",
      "B7G5000-BL1",
    ];

    const handPumpProductSkus = [
      "ADF520",
      "ADF520F",
      "ADF420MOL",
      "ADF420B",
      "ADF420F",
      "ADF420Y",
      "ADF540W",
      "ADF541W",
      "ADF550DFL",
      "ADF551DFL",
      "ADF561NL",
    ];
    const isHandPump = handPumpProductSkus.includes(selectedVariantSku);
    const isPentagonDeluxe = pentagonDeluxeProductSkus.includes(selectedVariantSku);
    console.log("この商品のsku：",selectedVariantSku,"...handpump:",isHandPump,"...pentagon",isPentagonDeluxe)
    //26.9.10判断基準sku-----------End
     //26.7.1B7G5000-BL2キャンペーン
    const basketballBagHandles = ["products/b7g5000-bl2"];
    const isBasketballBag = basketballBagHandles.some((handle) =>
      pageUrl.includes(handle)
    );
    if (isBlazzaSilver) additionalsToCartSilverOnly(event, btn);
    else if (isHLeague2026) additionalsToCartHLeague2026(event,btn);
    else if (isBasketballBag) additionalsToCartBasketballBag(btn);
    else if (isPentagonDeluxe) additionalsToCartPentagonDeluxe(btn);
    else if (isHandPump) additionalsToCartHandPumpBlue(btn);
    else addProductToCart(btn);

  });
});

/*******************************/
// FLOATING BAR HIDE & SHOW
let floatAddBtn = document.getElementById("float-add");
let floatBuyBtn = document.getElementById("float-buy");

floatAddBtn.addEventListener("click", () => {
  floatAddBtn.classList.toggle("active");
  floatBuyBtn.classList.toggle("active");
});

/*******************************/

// RENDER FEATURED PRODUCTS
const renderLoadObserver = new IntersectionObserver((entries) => {
  if (!entries[0].isIntersecting) return;

  let parent = entries[0].target;
  let target = parent.querySelector("template");
  let template = target.content.cloneNode(true);
  target.after(template);
  renderLoadObserver.unobserve(productFeaturedSetContainer);
  setTimeout(() => {
    parent.classList.add(parent.id + "--active");
  }, 1000);
});

let productFeaturedSetContainer = document.getElementById(
  "product-featured-set"
);
if (productFeaturedSetContainer)
  renderLoadObserver.observe(productFeaturedSetContainer);

/*******************************/

// CART BUNDLE CUSTOM
if (cartCustomButton)
  cartCustomButton.forEach((button) => {
    if (!customBundleCart) return;

    let formData = { items: [] };

    button.addEventListener("click", () => {
      button.setAttribute("disabled", true);
      button.classList.add("disabled");

      const cartSet = customBundleCart.find((v) =>
        v.sku.includes(selectedProductVariant.sku)
      );

      if (!cartSet) return;

      cartSet.product_id.forEach((i) =>
        formData.items.push({
          id: i,
          quantity: quantitySelector.value,
        })
      );

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log(data);

          if (data.description) {
            alert(data.description);
            //button.removeAttribute('disabled')
            //button.classList.remove('disabled')
          }

          window.location.href = "/cart";
        })
        .finally(() => {})
        .catch((error) => {
          button.removeAttribute("disabled");
          button.classList.remove("disabled");
          console.error("Error:", error);
        });
    });
  });

/*******************************/
// PRODUCT IMAGE SWIPE FUNCTIONALITY

// スワイプ用の状態管理
let swipeState = {
  startX: 0,
  startY: 0,
  currentX: 0,
  currentY: 0,
  isDragging: false,
  threshold: 50, // スワイプ検出の最小距離（px）
  currentImageIndex: 0,
  visibleThumbnails: [] // 現在表示中のサムネイル配列
};

// 表示中のサムネイル配列を更新する関数
function updateVisibleThumbnails() {
  requestAnimationFrame(() => {
    swipeState.visibleThumbnails = Array.from(thumbnail).filter((img) => {
      const computedStyle = window.getComputedStyle(img);
      return computedStyle.display !== 'none';
    });
    
    // 初期アクティブサムネイル設定（配列更新完了後）
    if (productPhotoImage && productPhotoImage.src) {
      swipeState.currentImageIndex = getCurrentImageIndex(productPhotoImage.src);
      updateActiveThumbnail(swipeState.currentImageIndex);
    }
    
    // スワイプナビゲーションボタンの表示を更新
    updateSwipeNavButtons();
  });
}

// 現在表示中の画像のインデックスを取得
function getCurrentImageIndex(imageSrc) {
  // サムネイルのsrcから&width=100を除去して比較
  const cleanSrc = imageSrc.replace(/&width=\d+/g, '');

  const index = swipeState.visibleThumbnails.findIndex((img) => {
    const thumbCleanSrc = img.src.replace(/&width=\d+/g, '');
    return cleanSrc.includes(thumbCleanSrc) || thumbCleanSrc.includes(cleanSrc);
  });

  return index >= 0 ? index : 0;
}

// サムネイルのアクティブクラスを更新
function updateActiveThumbnail(index) {
  // 全てのサムネイルからアクティブクラスを削除
  thumbnail.forEach((img) => {
    img.classList.remove('thumbnail__item--active');
  });

  // 指定されたインデックスのサムネイルにアクティブクラスを追加
  if (swipeState.visibleThumbnails[index]) {
    swipeState.visibleThumbnails[index].classList.add('thumbnail__item--active');
  }
  // 1枚目の画像のみバッジを表示
  const featuredMediaBadge = document.querySelector('[data-featured-media-badge]');
  if (featuredMediaBadge) {
    featuredMediaBadge.style.display = index === 0 ? '' : 'none';
  }
}

// スワイプによる画像切り替え
function switchImageBySwipe(direction) {
  const totalImages = swipeState.visibleThumbnails.length;

  if (totalImages === 0) return;

  // 方向に応じてインデックスを更新
  if (direction === 'left') {
    swipeState.currentImageIndex = (swipeState.currentImageIndex + 1) % totalImages;
  } else if (direction === 'right') {
    swipeState.currentImageIndex = (swipeState.currentImageIndex - 1 + totalImages) % totalImages;
  }

  // 対象のサムネイルを取得
  const targetThumbnail = swipeState.visibleThumbnails[swipeState.currentImageIndex];

  if (targetThumbnail) {
    // フェードアウト効果（既存コードを踏襲）
    if (initialPhoto !== targetThumbnail.src) {
      productFeaturedContainer.style.opacity = 0.5;
      initialPhoto = targetThumbnail.src;
    }

    // メイン画像のsource要素を更新
    productFeaturedSource.forEach((src) => {
      src.srcset = `${targetThumbnail.src.replace(
        '&width=100',
        '&width=' + src.width
      )} 1x,${targetThumbnail.src.replace(
        '&width=100',
        '&width=' + src.width * 2
      )} 2x `;
    });

    // アクティブサムネイルを更新
    updateActiveThumbnail(swipeState.currentImageIndex);
  }
}


// タッチ開始
function handleTouchStart(e) {
  swipeState.startX = e.touches ? e.touches[0].clientX : e.clientX;
  swipeState.startY = e.touches ? e.touches[0].clientY : e.clientY;
  swipeState.isDragging = true;
}

// タッチ移動
function handleTouchMove(e) {
  if (!swipeState.isDragging) return;

  swipeState.currentX = e.touches ? e.touches[0].clientX : e.clientX;
  swipeState.currentY = e.touches ? e.touches[0].clientY : e.clientY;
}

// タッチ終了
function handleTouchEnd(e) {
  if (!swipeState.isDragging) return;

  const deltaX = swipeState.currentX - swipeState.startX;
  const deltaY = swipeState.currentY - swipeState.startY;

  // 水平方向の移動が垂直方向より大きい場合のみスワイプ判定
  if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > swipeState.threshold) {
    if (deltaX > 0) {
      // 右スワイプ（前の画像へ）
      switchImageBySwipe('right');
    } else {
      // 左スワイプ（次の画像へ）
      switchImageBySwipe('left');
    }
  }

  swipeState.isDragging = false;
  swipeState.startX = 0;
  swipeState.startY = 0;
  swipeState.currentX = 0;
  swipeState.currentY = 0;
}

// スワイプイベントリスナーを登録
if (productFeaturedContainer) {
  // タッチイベント（モバイル）
  productFeaturedContainer.addEventListener('touchstart', handleTouchStart, { passive: true });
  productFeaturedContainer.addEventListener('touchmove', handleTouchMove, { passive: true });
  productFeaturedContainer.addEventListener('touchend', handleTouchEnd);

  // マウスイベント（デスクトップ）
  productFeaturedContainer.addEventListener('mousedown', handleTouchStart);
  productFeaturedContainer.addEventListener('mousemove', handleTouchMove);
  productFeaturedContainer.addEventListener('mouseup', handleTouchEnd);
  productFeaturedContainer.addEventListener('mouseleave', handleTouchEnd);
}

// スワイプナビゲーションボタンの表示/非表示を制御
function updateSwipeNavButtons() {
  const navButtons = document.querySelector('[data-swipe-nav]');
  if (navButtons) {
    if (swipeState.visibleThumbnails.length > 1) {
      navButtons.classList.add('is-active');
    } else {
      navButtons.classList.remove('is-active');
    }
  }
}

// 初期化: 表示中のサムネイル配列を構築（アクティブ設定とボタン表示も含む）
updateVisibleThumbnails();

// スワイプナビゲーションボタンのクリックイベント
const prevButton = document.querySelector('[data-swipe-prev]');
const nextButton = document.querySelector('[data-swipe-next]');

// ボタン連打防止用の状態管理（画像切り替え完了まで）
let isButtonProcessing = false;

if (prevButton) {
  prevButton.addEventListener('click', () => {
    if (isButtonProcessing) return;
    
    isButtonProcessing = true;
    switchImageBySwipe('right');
    // 画像読み込み完了時にisButtonProcessingがfalseに設定される
  });
}

if (nextButton) {
  nextButton.addEventListener('click', () => {
    if (isButtonProcessing) return;
    
    isButtonProcessing = true;
    switchImageBySwipe('left');
    // 画像読み込み完了時にisButtonProcessingがfalseに設定される
  });
}


//サイズのバリエーションボタン26.4.2 リ
function updateSizeButtons(variant) {
  currentColor = variant.option1;

  const sizeButtons = document.querySelectorAll('.details-size-button[data-product-url]');

  sizeButtons.forEach((button) => {
    const targetProductUrl = button.dataset.productUrl;
    const variantsData = button.dataset.variants;

    if (!targetProductUrl || !variantsData) return;

    let variants = [];

    try {
      variants = JSON.parse(variantsData);
    } catch (e) {
      button.href = targetProductUrl;
      return;
    }

    const matchedVariant = variants.find((v) => v.color === currentColor);

    if (matchedVariant) {
      button.href = `${targetProductUrl}?variant=${matchedVariant.id}`;
    } else {
      button.href = targetProductUrl;
    }
  });
  const arSection = document.querySelector('.custom-ar-section');
  if (
    arSection &&(currentHandle === 'rb-bgset2' || currentHandle === 'rb-bmset6')
  ){
  const url = new URL(window.location.href);
  url.hash = '';
  url.searchParams.set('variant', variant.id);
  window.location.href = url.toString();
  }
}
//サイズのバリエーションボタン26.4.2 リ

//通常商品のフォームサブミットの代わりの送信　26.10.2
async function addProductToCart(button) {
  const originalButtonText = button.textContent;
  button.disabled = true;
  button.classList.add("disabled");
  button.textContent = "追加中...";
  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      body: new FormData(form),
      headers: {
        Accept: "application/json",
      },
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("カート追加エラー:", data);

      showActionToast({
        message:
          data.description ||
          data.message ||
          "カートに追加できませんでした。",
      });

      return;
    }

    const cartResponse = await fetch("/cart.js");
    const cart = await cartResponse.json();

    const freeShippingThreshold =(window.isCustomerLoggedIn ? 5500 : 11000) * 100;
    const remainingPrice = freeShippingThreshold - cart.total_price;
    const hideShippingMessage = cart.items.some(
      (item) => item.handle === 'rb-bgset2' || item.handle === 'rb-gmset'
    );
    let message = "カートに追加済み";
    console.log(hideShippingMessage);
if (hideShippingMessage) {

  toastShipMessage = '';

} 
    else if (remainingPrice > 0) {
     toastShipMessage = `
あと${formatPrice(remainingPrice)}で送料無料です！<br><small>
<a href="/account/login">会員ログイン</a>で送料無料ラインが<br>11,000円→5,500円に！</small>
`;
    } else {
      toastShipMessage = `送料無料が適用されます。`;
    }

    showActionToast({
      message,
      shipmessage:toastShipMessage,
      product: {
        title: data.product_title,
        variantTitle: data.variant_title,
        quantity: Number(productQuantity.value),
        image: data.featured_image?.url || data.image,
        options: data.options_with_values || [],
      },
      linkText: `カートを見る（${cart.item_count}）`,
      onClick: () => {
        location.href = "/cart";
      },
      duration:10000,
    });
  } catch (error) {
    console.error(error);

    showActionToast({
      message: "通信エラーが発生しました。",
    });
  } finally {
    button.disabled = false;
    button.classList.remove("disabled");
    button.textContent = originalButtonText;
  }
}
function formatPrice(price) {
  return `${new Intl.NumberFormat("ja-JP").format(price / 100)}円`;
}

const arHowtoModal = document.getElementById('js-ar-howto-modal');

if (arHowtoModal) {
  const arHowtoOverlay = arHowtoModal.querySelector('.ar-howto-overlay');
  const arHowtoInner = arHowtoModal.querySelector('.ar-howto-inner');
  const arHowtoTrigger = document.getElementById('js-ar-howto-trigger');
  const arHowtoClose = document.getElementById('js-modal-close');

  arHowtoTrigger?.addEventListener('click', function() {
    arHowtoModal.classList.add('is-open');
  });

  arHowtoClose?.addEventListener('click', function() {
    arHowtoModal.classList.remove('is-open');
  });

  arHowtoOverlay?.addEventListener('click', function() {
    arHowtoModal.classList.remove('is-open');
  });

  arHowtoInner?.addEventListener('click', function(event) {
    event.stopPropagation();
  });
}